const colors = {
  $white: '#ffffff',
  $black: '#000000',
  $dark: '#21354A',
  $dark_light: '#435167',
  $dark_medium: '#374D65',
  $ebony_clay: '#2A3442',
  $primary: '#007bff',
  $primary_medium: '#b9daff',
  $primary_light: '#edf5ff',
  $info: '#17a2b8',
  $success: '#28a745',
  $success_light_bg: '#D4EDDA',
  $success_light_bg_hover: '#C3E6CB',
  $warning: '#ffc107',
  $warning_light_bg: '#FFF3CD',
  $warning_light_bg_hover: '#FFE69C',
  $danger: '#dc3545',
  $danger_light_bg: '#F8D7DA',
  $danger_light_bg_hover: '#F5C6CB',
  $danger_border_strong: '#C10007',
  $badge_danger_stroke: '#8F222D',
  $badge_danger_fill: 'rgba(220, 53, 69, 0.15)',
  $badge_success_fill: 'rgba(40, 167, 69, 0.15)',
  $badge_success_text: '#165C26',
  $badge_secondary_stroke: '#464C51',
  $badge_secondary_fill: 'rgba(108, 117, 125, 0.15)',
  $badge_secondary_text: '#3B4045',
  $badge_white_stroke: '#8D8D8D',
  $badge_white_fill: 'rgba(217, 217, 217, 0.15)',
  $badge_white_text: '#777777',
  $dark_green: '#0D875E',
  $primary_green: '#009F79',
  $primary_green_light: '#03D6A5',
  $secondary_green: '#b2ffec',
  $secondary_green_light: '#CAE9DE',
  $bg_green: '#edfffa',
  $bg_green_register: '#0D875E',
  $orange: '#FD6602',
  $light_orange: '#FDA117',
  $campaign_recharges_orange: '#e8802c',
  $renewal_color: '#12908D',
  $pink: '#FA0368',
  $bg_gray: '#f0f1f2',
  $light_border: '#9e9696',
  $keyword: '#ffdf8f',
  $gray100: '#f8f9fa',
  $gray200: '#e9ecef',
  $gray300: '#dee2e6',
  $gray400: '#ced4da',
  $gray500: '#adb5bd',
  $gray600: '#6c757d',
  $gray700: '#495057',
  $gray800: '#343a40',
  $gray900: '#212529',
  $gray55: '#8C8C8C',
  $yellow: '#FFD159',
  $gold: '#B47700',
  $bg_blue: '#2898AB',
  $dark_slate_blue: '#354153',
  $purple: '#956CCA',
  $purple_conlicitantes: '#6B1096',
  $brown: '#7A5D06',
  $charcoal: '#2F415B',
  $deep_police_blue: '#41526B',
  $dark_electric_blue: '#5E6D83',
  $black_coral: '#4D5E77',
  $manatee: '#929AA7',
  $dark_charcoal: '#333333',
  $green: '#21af7c',
  $green_orchid: '#6CD8B4',
  $red: '#D23351',
  $light_blue: '#25ABC9',
  $medium_green: '#21AF7C',
  $japanese_indigo: '#1F3E4F',
  $yankees_blue: '#19323F',
  $police_blue: '#294E65',
  $metallic_blue: '#345C74',
  $ocean_green: '#108367',
  $steel_blue: '#21354A',
  $blue800: '#284664',
  $blue600: '#3F6189',
  $blue400: '#5A86B1',
  $blue300: '#7FA6CC',
  $conlicitacao_banner_gradient_start: '#3D8488',
  $conlicitacao_banner_gradient_end: '#097178',
  $conlicitacao_banner_border: '#036C72',
  $conlicitacao_banner_button_bg: '#D5E9EA',
  $conlicitacao_banner_button_text: '#2A4E6E',
};

export default colors;
